export default [
  {
    path: '/importarArquivoTexto/',
    name: 'importarArquivoTexto',
    title: 'Importar Arquivo Texto',
    component: () => import('../views/ImportarArquivoTextoView.vue'),
    redirect: { name: 'importarArquivoTexto-welcome' },
    children: [
      {
        path: 'welcome',
        name: 'importarArquivoTexto-welcome',
        component: () => import('../views/ImportarArquivoTextoWelcomeView.vue'),
        meta: {
          title: 'Importar Arquivo Texto',
        },
      },
      {
        path: 'produtos',
        name: 'importarArquivoTexto-produtos',
        component: () => import('../views/ImportarArquivoTextoProdutoFormView.vue'),
        meta: {
          title: 'Importar Produtos',
        },
      },
      {
        path: 'clientes',
        name: 'importarArquivoTexto-clientes',
        component: () => import('../views/ImportarArquivoTextoClienteFormView.vue'),
        meta: {
          title: 'Importar Clientes',
        },
      },
      {
        path: 'financeiro',
        name: 'importarArquivoTexto-financeiro',
        component: () => import('../views/ImportarArquivoTextoFinanceiroFormView.vue'),
        meta: {
          title: 'Importar Recebíveis',
        },
      },
    ],
  },
];
